import { Fragment } from "react";

import ChatIcon from "@mui/icons-material/Chat";
import { useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { alpha, lighten } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import OmniAvatar from "./omniAvatar";

const SymptomTrackingToDoListItem = props => {
  const { index = 0, onClickHandler = null } = props;
  const theme = useTheme();

  return (
    <ListItem
      dense
      key={index}
      disableGutters={true}
      onClick={() => {
        onClickHandler();
      }}
      sx={[
        {
          padding: theme.spacing(1),
          paddingTop: 0,
          paddingBottom: 0,
          marginBottom: theme.spacing(1),
          borderRadius: theme.spacing(1),
          boxShadow: theme.shadows[3],
          color: theme.palette.secondary.contrastText,
        },
        {
          backgroundColor: theme.palette.secondary.main,
          "&:hover": {
            backgroundColor: alpha(theme.palette.secondary.main, 0.5),
            cursor: "pointer",
          },
        },
      ]}
    >
      <Tooltip title="Last Value" placement="top">
        <OmniAvatar
          sx={[
            {
              width: 42,
              height: 42,
              fontSize: "1.2rem",
              boxShadow: theme.shadows[3],
            },
            {
              color: theme.palette.secondary.contrastText,
              backgroundColor: lighten(theme.palette.secondary.main, 0.25),
              border: `2px solid ${theme.palette.secondary.contrastText}`,
            },
          ]}
        >
          {<ChatIcon />}
        </OmniAvatar>
      </Tooltip>
      <ListItemText
        primary={
          <Typography
            component="span"
            variant="h6"
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: 0,
              color: theme.palette.secondary.contrastText,
              webkitUserSelect: "none",
              userSelect: "none",
            }}
          >
            {"Learn more about Long COVID"}
          </Typography>
        }
        secondary={
          <Fragment>
            <Typography
              component="span"
              variant="subtitle2"
              color="textPrimary"
              sx={{
                display: "flex",
                flexDirection: "row",
                marginLeft: theme.spacing(1),
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                marginTop: "-6px",
                color: theme.palette.secondary.contrastText,
                webkitUserSelect: "none",
                userSelect: "none",
              }}
            >
              {"Click Here to ask your A.I. assistant"}
            </Typography>
          </Fragment>
        }
      />
    </ListItem>
  );
};

export default SymptomTrackingToDoListItem;
